"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vigonza": {
    "c8b1104e": [{
      "hkey": "ba9ca405",
      "slug": "vigonza",
      "name": "Vigonza",
      "primary": true,
      "skipSearch": false
    }],
    "bagnoli": [{
      "hkey": "ba9ca405",
      "slug": "vigonza",
      "name": "Vigonza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b66971c": [{
      "hkey": "ba9ca405",
      "slug": "vigonza",
      "name": "Vigonza",
      "primary": true,
      "skipSearch": false
    }],
    "battana-prati": [{
      "hkey": "ba9ca405",
      "slug": "vigonza",
      "name": "Vigonza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "434dd9c6": [{
      "hkey": "ba9ca405",
      "slug": "vigonza",
      "name": "Vigonza",
      "primary": true,
      "skipSearch": false
    }],
    "santamaria": [{
      "hkey": "ba9ca405",
      "slug": "vigonza",
      "name": "Vigonza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1d6181b4": [{
      "hkey": "7476a825",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "vigonza": [{
      "hkey": "7476a825",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;